import React from "react";
import styles from "../static/styles/RewardClaimPopup.module.css";
import goldCoinsImage from "../static/img/Home/creditIcon.png";
import arrowRight from "../static/img/DailyCheckin/arrowRight.svg";

const RewardClaimPopup = ({ isOpen, onClose, credits = 15 }) => {
  if (!isOpen) return null;

  return (
    <div className={styles.popupOverlay} onClick={onClose}>
      <div className={styles.popupContent} onClick={(e) => e.stopPropagation()}>
        <div className={styles.coinsContainer}>
          <img
            src={goldCoinsImage}
            alt="Gold Coins"
            className={styles.coinsImage}
          />
        </div>
        <h2 className={styles.title}>Congratulations!</h2>
        <h2 className={styles.subtitle}>
          Your daily login streak earn tou a reward!
        </h2>
        <div className={styles.credits}>+ {credits} Credits</div>
        <button className={styles.rewardButton} onClick={onClose}>
          KEEP IT GOING{" "}
          <img src={arrowRight} alt="Arrow" className={styles.buttonIcon} />
        </button>
      </div>
    </div>
  );
};

export default RewardClaimPopup;
